/** SSR-safe read of the viewer's reduced-motion preference (all six portals are
 *  CSR Vite apps, but guard `window` for correctness). Read at render time so a
 *  mid-session OS change is picked up on the next open. */
export function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/** True below the mobile breakpoint — the drawer goes full-width there. */
export function isNarrowViewport(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia('(max-width: 640px)').matches;
}
